export default "__VITE_ASSET__e24f794e__"